import isFunction from 'lodash/isFunction'
import type React from 'react'

export type ShowIfProps = {
  condition: boolean
  children: React.ReactNode
}

export const ShowIf = ({ condition, children }: { condition: boolean; children: React.ReactNode }) => {
  //check if is the condition is a function or just a boolean value
  if (isFunction(condition)) {
    //just execute it and overwrite the existing value
    condition = condition()
  }
  //this should be fixed

  //if the condition says true then show the children
  const content = children || null
  if (!condition) {
    return null
  }

  return content
}
